var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    fill: "currentColor",
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19872 6.45413C2.30446 6.72505 2.46989 6.96786 2.68235 7.16397C2.89481 7.36009 3.14867 7.50432 3.42453 7.58563L9.49144 9L3.48157 10.3359C3.19936 10.4143 2.93896 10.5581 2.72094 10.756C2.50293 10.9539 2.33326 11.2006 2.22534 11.4764L0.782772 16.5862C0.703843 16.7844 0.687772 17.0027 0.736793 17.2106C0.785814 17.4185 0.897491 17.6058 1.0563 17.7464C1.2151 17.8869 1.41314 17.9738 1.62289 17.995C1.83263 18.0161 2.04365 17.9704 2.22661 17.8643L16.1858 9.90005C16.3443 9.8111 16.4765 9.6807 16.5685 9.52242C16.6605 9.36413 16.709 9.18374 16.709 9C16.709 8.81625 16.6605 8.63586 16.5685 8.47758C16.4765 8.3193 16.3443 8.1889 16.1858 8.09995L2.22661 0.135749C2.04365 0.0295983 1.83263 -0.0160905 1.62289 0.00503504C1.41314 0.0261606 1.2151 0.113051 1.0563 0.253624C0.897491 0.394198 0.785814 0.581469 0.736793 0.7894C0.687772 0.997331 0.703843 1.21559 0.782772 1.41383L2.19872 6.45413Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.c9991e1837b9f52c4adfd6d21158ba67.svg";
export { ForwardRef as ReactComponent };